import { Component, Input } from '@angular/core';
import { SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'bepatient-onboarding-title',
  templateUrl: './onboarding-title.component.html',
  styleUrls: ['./onboarding-title.component.scss'],
  standalone: false
})
export class OnboardingTitleComponent {
  @Input() title: string;
  @Input() color: string | SafeStyle;
}
